import { render } from "./ProfileOrderList.vue?vue&type=template&id=7ec1377e"
import script from "./ProfileOrderList.vue?vue&type=script&lang=js"
export * from "./ProfileOrderList.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__